<template>
  <!-- 弹窗选择商品 -->
  <div>
    <h-dialog
      title="选择商品"
      width="800px"
      v-model="chooseShopsDialog"
      :confirm-loading="confirmLoading"
      @onOk="ok"
      @onCancel="cancel"
      align-center
    >
      <h-table
        ref="chooseShopsTableRef"
        :http="getList"
        :columns="columns"
        :query-form="queryForm"
        :show-reset="false"
        :show-query="false"
        vuex-namespace="chooseShopsTable"
        row-key="code"
        :autoRequest="false"
        type="selection"
        @result="getResult"
        @selection-change="handleSelectionChange"
      >
        <template #logo_url="{ row }">
          <el-image
            :src="row.logo_url"
            :preview-src-list="[row.logo_url]"
            style="cursor: pointer; width: auto; height: 25px"
            preview-teleported
            fit="fill"
          />
        </template>
      </h-table>
    </h-dialog>
    <!-- 商品选择表单 -->
    <!-- <el-form-item label="适用商品:"> -->
    <el-radio-group v-model="goods_range">
      <el-radio :value="2" @click="chooseShopsFn(2)">全部商品</el-radio>
      <el-radio
        :value="0"
        @click="chooseShopsFn(0)"
        :disabled="!changeShop?.length"
        >在售商品</el-radio
      >
      <el-radio :value="1" @click="chooseShopsFn(1)">商品库商品</el-radio>
    </el-radio-group>
    <!-- </el-form-item> -->
    <!-- 在售商品 -->
    <div style="display: flex; margin-top: 10px" v-if="goods_range === 0">
      <el-button type="primary" @click="chooseShopsFn(0)">添加</el-button>
      <el-button
        @click="deleteAllOnSaleFn"
        :disabled="!selectedGoodsOnSale.length"
        >一键删除</el-button
      >
    </div>
    <!-- 全部商品 -->
    <div style="display: flex; margin-top: 10px" v-if="goods_range === 1">
      <el-button type="primary" @click="chooseShopsFn(1)">添加</el-button>
      <el-button @click="deleteAllFn" :disabled="!selectedGoods.length"
        >一键删除</el-button
      >
    </div>
    <!-- 已选择的商品列表 -->
    <div
      class="selected-goods-list"
      v-bind="customAttrs"
      v-if="
        (goods_range == 1 && selectedGoods.length) ||
        (goods_range == 0 && selectedGoodsOnSale.length)
      "
    >
      <h-simple-table
        ref="multipleTableRef"
        :columns="selectedGoodsColumn"
        :dataSource="goods_range === 0 ? tableDataOnSale : tableData"
        row-key="id"
        :pagination="{
          layout: 'prev, pager, next',
          pageSize: 5,
          pagerCount: 5,
        }"
        wrapper
      >
        <template #logo_url="{ row }">
          <el-image
            :src="row.logo_url"
            :preview-src-list="[row.logo_url]"
            :preview-teleported="true"
            :initial-index="4"
            fit="fill"
            style="cursor: pointer; width: 35px; height: 35px"
          />
        </template>
        <template #operation="{ row }">
          <h-link type="danger" @click="handleDelete(row)" :disabled="isDetail">删除</h-link>
        </template>
        <template #pagination>
          <div class="pagination">
            <el-pagination
              v-if="goods_range === 0 && selectedGoodsOnSale.length > 0"
              v-model:current-page="pageDataOnSale.page"
              hide-on-single-page
              v-model:page-size="pageDataOnSale.size"
              :page-sizes="[5, 10, 20]"
              layout="total, prev, pager, next"
              :total="selectedGoodsOnSale.length"
            />
            <el-pagination
              v-else-if="goods_range === 1 && selectedGoods.length > 0"
              v-model:current-page="pageData.page"
              hide-on-single-page
              v-model:page-size="pageData.size"
              :page-sizes="[5, 10, 20]"
              layout="total, prev, pager, next"
              :total="selectedGoods.length"
            />
          </div>
        </template>
      </h-simple-table>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, nextTick, watch, computed } from 'vue';
import {
  searchGoodsListApi,
  goodsListApi,
} from '@/api/marketing/activities-management';
import { queryForm, columns, selectedGoodsColumn } from './constants';
import { ElMessage } from 'element-plus';
const goods_range = defineModel('goods_range');
const props = defineProps(['changeShop', 'customAttrs','isDetail']); // 当前选择的店铺 需要在售商品需要拿到当前选择的店铺

const emit = defineEmits(['changeGoods']);
// 弹窗相关
const chooseShopsDialog = ref(false);
const chooseShopsTableRef = ref();
const confirmLoading = ref(false);

// 商品数据
const temporarySelectedGoods = ref([]); // 临时选中的商品
const selectedGoods = ref([]); // 最终选中的商品 商品库商品
const selectedGoodsOnSale = ref([]); // 最终选中的商品 在售商品
// const displayGoods = ref([]) // 当前分页显示的商品列表
// 分页数据
const pageDataOnSale = reactive({
  page: 1,
  size: 5,
});
const pageData = reactive({
  page: 1,
  size: 5,
});
const tableDataOnSale = computed(() => {
  return selectedGoodsOnSale.value.slice(
    (pageDataOnSale.page - 1) * pageDataOnSale.size,
    pageDataOnSale.page * pageDataOnSale.size
  );
});
const tableData = computed(() => {
  return selectedGoods.value.slice(
    (pageData.page - 1) * pageData.size,
    pageData.page * pageData.size
  );
});
// 选择商品类型
const chooseShopsFn = async (value) => {
  if (isDetail.value) {
    return;
  }
  if (value === 0) {
    if (!props.changeShop.length) {
      ElMessage.error('请先选择店铺');
      return;
    }
    chooseShopsDialog.value = true;
    temporarySelectedGoods.value = []; //清空弹窗中临时选中的商品

    // 先更新 goods_range 的值
    goods_range.value = value;

    // 等待数据更新完成
    await nextTick();

    chooseShopsTableRef.value?.refresh();
    chooseShopsTableRef.value?.tableFn('clearSelection');

    if (selectedGoodsOnSale.value.length) {
      temporarySelectedGoods.value = selectedGoodsOnSale.value;
      selectedGoodsOnSale.value.forEach((item) => {
        chooseShopsTableRef.value.tableFn('toggleRowSelection', item, true);
      });
    }
    emit('changeGoods', selectedGoodsOnSale.value);
  } else if (value === 1) {
    // 先打开弹窗
    chooseShopsDialog.value = true;
    temporarySelectedGoods.value = [];

    // 先更新 goods_range 的值
    goods_range.value = value;

    // 等待数据更新完成
    await nextTick();
    chooseShopsTableRef.value?.refresh(); //请求列表鸟接口
    chooseShopsTableRef.value?.tableFn('clearSelection');
    if (selectedGoods.value.length) {
      temporarySelectedGoods.value = selectedGoods.value;
      selectedGoods.value.forEach((item) => {
        chooseShopsTableRef.value.tableFn('toggleRowSelection', item, true);
      });
    }
    emit('changeGoods', selectedGoods.value);
  } else {
    goods_range.value = value;
    await nextTick();
    emit('changeGoods', []);
  }
};

// 获取商品列表
const getList = (params) => {
  let data = {};
  if (goods_range.value === 0) {
    // 在售商品
    data.shop_ids = props.changeShop.join(',');
    return searchGoodsListApi({ ...params, ...data });
  } else {
    // 商品库商品
    data.enable = 1;
    return goodsListApi({ ...params, ...data });
  }
};

// 选择商品变化
const handleSelectionChange = (selection) => {
  temporarySelectedGoods.value = selection;
  // console.log('当前选中的商品:', selection)
};

// 获取查询结果
const getResult = (res) => {
  // console.log('查询结果:', res)
};

// 更新显示的商品列表
const updateDisplayGoods = () => {
  const start = Math.max(0, (pageData.page - 1) * pageData.size);
  const end = Math.max(start + pageData.size, start);
  if (goods_range.value === 0) {
    if (start < selectedGoodsOnSale.value.length) {
      displayGoods.value = selectedGoodsOnSale.value.slice(start, end);
    } else {
      displayGoods.value = [];
    }
    // displayGoods.value = selectedGoodsOnSale.value.slice(start, end)
  } else if (goods_range.value === 1) {
    if (start < selectedGoods.value.length) {
      displayGoods.value = selectedGoods.value.slice(start, end);
    } else {
      displayGoods.value = [];
    }
    // displayGoods.value = selectedGoods.value.slice(start, end)
  }
};

// 弹窗操作
const cancel = () => {
  chooseShopsTableRef.value.tableFn('clearSelection');
  chooseShopsTableRef.value?.reset(); 
};

const ok = () => {
  // 合并新选中的商品,去重
  if (goods_range.value === 0) {
    selectedGoodsOnSale.value = [...temporarySelectedGoods.value];
    emit('changeGoods', selectedGoodsOnSale.value);
    pageData.total = selectedGoodsOnSale.value.length;
  } else if (goods_range.value === 1) {
    selectedGoods.value = [...temporarySelectedGoods.value];
    emit('changeGoods', selectedGoods.value);
    pageData.total = selectedGoods.value.length;
  }
  chooseShopsDialog.value = false;
  chooseShopsTableRef.value?.reset(); 
};

// 删除已选商品
const handleDelete = (row) => {
  if (goods_range.value === 0) {
    selectedGoodsOnSale.value = selectedGoodsOnSale.value.filter(
      (item) => item.code !== row.code
    );
    emit('changeGoods', selectedGoodsOnSale.value);
    pageData.total = selectedGoodsOnSale.value.length;
  } else if (goods_range.value === 1) {
    selectedGoods.value = selectedGoods.value.filter(
      (item) => item.code !== row.code
    );
    emit('changeGoods', selectedGoods.value);
    pageData.total = selectedGoods.value.length;
  }
};
const deleteAllFn = () => {
  selectedGoods.value = [];
  emit('changeGoods', selectedGoods.value);
  pageData.total = selectedGoods.value.length;
};
const deleteAllOnSaleFn = () => {
  selectedGoodsOnSale.value = [];
  emit('changeGoods', selectedGoodsOnSale.value);
  pageDataOnSale.total = selectedGoodsOnSale.value.length;
};
const isDetail = ref(false);
const showDetailGoods = async (data, disabled) => {
  // console.log('showDetailGoods', data)
  await nextTick();
  // console.log(goods_range.value, '当前选择的商品类型')
  isDetail.value = disabled;
  if (goods_range.value === 0) {
    selectedGoodsOnSale.value = data;
  } else if (goods_range.value === 1) {
    selectedGoods.value = data;
  }
};
defineExpose({
  showDetailGoods,
});
watch(
  () => props.changeShop,
  (changeShop) => {
    if (!changeShop.length && goods_range.value === 0) {
      ElMessage.error('请先选择店铺');

      goods_range.value = selectedGoods.value.length ? 1 : null;
      temporarySelectedGoods.value = [];
      selectedGoodsOnSale.value = [];
    }
  },
  {
    deep: true, // 深度监听数组变化
    // immediate: true, // 立即执行
  }
);
</script>

<style lang="scss" scoped>
.delete-btn {
  color: #ffaf54;
  cursor: pointer;
}

.selected-goods-list {
  width: 800px;
  margin-top: 10px;
  .x-table-page {
    padding: 0;
    margin: 0;
  }
}

.pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

:deep(.form-row) {
  max-width: 50% !important;
  flex: 2 !important;
}
</style>
